import decode from 'jwt-decode';
import { SESSION_IDLE_TIMEOUT } from 'config';
import { REFRESH_HEADER, TOKEN_HEADER } from './auth-config';
import { DecodedToken } from './decoded-token.model';
import { Roles, User, UserRole } from './user.model';

export type AuthHeaders = {
  headers: {
    authorization: string;
    isTokenRefresh: boolean;
  };
  data?: { roles: UserRole[]; debtAuthorized: boolean };
};

export class LoginResponse {
  user!: User;

  token!: string;

  refreshToken!: string;

  static getUserData({ headers, data }: AuthHeaders): LoginResponse | null {
    if (!headers) {
      return null;
    }
    if (!headers.hasOwnProperty(TOKEN_HEADER)) {
      return null;
    }

    const instance = new LoginResponse();

    const decodedAuthorizationToken: DecodedToken = decode(
      headers.authorization
    );

    instance.user = {
      userName: decodedAuthorizationToken.user_name.toUpperCase(),
      displayName: decodedAuthorizationToken.display_Name,
      legajo: decodedAuthorizationToken.legajo,
      mailAddress: decodedAuthorizationToken.mail_address,
      roles: data?.roles ?? [{ name: Roles.FIJASTH_PY_VENTAS }],
      debtAuthorized: data?.debtAuthorized ?? false,
      lastActivityTime: new Date(
        new Date().getTime() + SESSION_IDLE_TIMEOUT * 1000
      )
        .getTime()
        .toString(),
    };

    instance.token = headers[TOKEN_HEADER];
    instance.refreshToken = headers[REFRESH_HEADER];

    return instance;
  }
}
